






import Vue from 'vue';

export default Vue.extend({
  name: 'UserIcon',
  props: {
    name: String,
    userId: String,
  },
  data() {
    return {
      photo: '',
    };
  },
  created() {
    // Check if users has a photo
    fetch(`https://api.pocketyoga.com/users/${this.userId}/photo?t=${Date.now()}`)
      .then((response) => {
        if (response.ok) {
          this.photo = `https://api.pocketyoga.com/users/${this.userId}/photo?t=${Date.now()}`;
        }
      });
  },
});
